module.exports = __webpack_public_path__ + "img/世界海空运航线.5844dd30.png";